import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import UtmsButton from '../ui/UtmsButton';

interface ModalConfirmProps {
    open: boolean;
    handleClose: () => void;
    handleSubmit: () => void;
    question: string;
    message?: string;
    action?: string;
    actionIcon?: React.ReactNode;
    close?: string;
}

const ModalConfirm = ({
    open,
    handleClose,
    handleSubmit,
    question,
    message,
    action,
    actionIcon,
    close,
}: ModalConfirmProps) => {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle variant="h4">{question}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ fontSize: '0.8rem' }}>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <UtmsButton color="error" onClick={handleSubmit} startIcon={actionIcon}>
                    {action || t('yes')}
                </UtmsButton>
                <UtmsButton onClick={handleClose} color="secondary">
                    {close || t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default ModalConfirm;
